export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KN-9396f4f26409c2f7fa9a3377d2215c97.png";